import { render, staticRenderFns } from "./ProductPerformance.vue?vue&type=template&id=856d95b8&scoped=true"
import script from "./ProductPerformance.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPerformance.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductPerformance.vue?vue&type=style&index=0&id=856d95b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856d95b8",
  null
  
)

export default component.exports